module.exports = __webpack_public_path__ + "img/etiquetes-adr.941d7809.jpg";